export type LastChanceDisplayStatus = 'active' | 'fulfilled' | 'formed' | 'ended' | 'cancelled';

export const LAST_CHANCE_DISPLAY_STATUS_LABELS: Record<LastChanceDisplayStatus, string> = {
  active: '모집중',
  fulfilled: '정원충족',
  formed: '편성완료',
  ended: '모집종료',
  cancelled: '폐강완료',
};

export interface LastChanceStatusInput {
  status: string;
  deadlineAt?: string;
}

export const isLastChancePastDeadline = (deadlineAt?: string, now = new Date()) =>
  !!deadlineAt && new Date(deadlineAt) <= now;

export function resolveLastChanceDisplayStatus(item: LastChanceStatusInput, now = new Date()): LastChanceDisplayStatus {
  if (item.status === 'cancelled') {
    return 'cancelled';
  }

  const isPastDeadline = isLastChancePastDeadline(item.deadlineAt, now);

  if (item.status === 'closed') {
    return isPastDeadline ? 'formed' : 'fulfilled';
  }

  return isPastDeadline ? 'ended' : 'active';
}

export function isLastChanceSaleEnded(item: LastChanceStatusInput, now = new Date()) {
  if (item.status === 'cancelled' || item.status === 'closed') {
    return true;
  }
  return isLastChancePastDeadline(item.deadlineAt, now);
}

export const LAST_CHANCE_DISPLAY_STATUS_TAG_COLORS: Record<LastChanceDisplayStatus, string> = {
  active: 'processing',
  fulfilled: 'warning',
  formed: 'success',
  ended: 'default',
  cancelled: 'default',
};
